import { render } from "./TrainingDetail_DataAnalysis.vue?vue&type=template&id=0364c28d&scoped=true"
import script from "./TrainingDetail_DataAnalysis.vue?vue&type=script&lang=js"
export * from "./TrainingDetail_DataAnalysis.vue?vue&type=script&lang=js"

import "./TrainingDetail_DataAnalysis.vue?vue&type=style&index=0&id=0364c28d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0364c28d"]])

export default __exports__